var userAgent = navigator.userAgent,
    publicPath = ""
if (!(userAgent.match("Chrome") || userAgent.match("Safari") || userAgent.match("Firefox") || userAgent.match("Edge"))) {
    alert("您的瀏覽器需要更新！請使用Google Chrome、Edge、Safari或Firefox等，將跳轉至Google Chrome下載頁面。"); window.location.href = "https://www.google.com/intl/zh-TW/chrome/";
}
var accessDeny = true,
    urlParams = new URLSearchParams(window.location.search),
    jwt_token = localStorage.getItem('jwt_token') || undefined,
    targetUrl = location.href,
    topicPara = urlParams.get('topic')
if (urlParams.has('code')) {
    // SSO登入完重導向
    $.ajax({
        url: publicPath + '/napi/get_oath_server_token',
        method: 'POST',
        async: false,
        data: { 'code': urlParams.get('code') }
    }).done(function (res) {
        if (res['access_token']) {
            $.ajax({
                url: publicPath + '/napi/get_oath_server_info',
                method: 'POST',
                async: false,
                data: { 'access_token': res['access_token'] }
            }).done(function (res) {
                accessDeny = false
                localStorage.setItem('jwt_token', res['jwt_token']);
                localStorage.setItem('user_unit_name', res['user_unit_name']);
                if (topicPara) {
                    location.assign(location.origin + location.pathname + "?topic=" + topicPara + '&version=test');
                } else {
                    location.assign(location.origin + location.pathname + '?version=test');
                }
            }).fail(function (jqXHR, textStatus) {
                alert('Get User Info Failed');
            });
        }
    }).fail(function (jqXHR, textStatus) {
        alert('Get Token Failed');
    });
} else {
    if (typeof jwt_token === 'string' && jwt_token.length > 0) {
        $.ajax({
            url: publicPath + '/napi/verify_jwt_token',
            method: 'POST',
            async: false,
            headers: {
                Authorization: 'Bearer ' + jwt_token,
            },
            contentType: "text/plain"
        }).done(function (res) {
            if (res === 'OK') {
                accessDeny = false
                localStorage.setItem('jwt_token', jwt_token);
            } else {
                localStorage.removeItem('jwt_token');
                localStorage.removeItem('jwt_token_swagger');
            }
        }).fail(function (jqXHR, textStatus) {
            // localStorage.removeItem('jwt_token');
            // localStorage.removeItem('jwt_token_swagger');
            alert('認證到期或認證失敗');
        });
    }
}
if (accessDeny) {
    window.location.href = 'login.html';
}